import { Module, MutationTree, ActionTree, GetterTree } from 'vuex'
import { RootState } from '@/types/store/index'
import { MenuState } from '@/types/store/menu'
import { MenuCategoryAttributes } from '@/types/models/menu-category'
import { axios, ApiResponse } from '@/plugins/axios'

const initialValues: MenuState = {
  menuCategories: undefined,
}

const state = (): MenuState => (initialValues)

const getters: GetterTree<MenuState, RootState> = {}

const mutations: MutationTree<MenuState> = {
  setMenuCategories (state, menuCategories?: MenuCategoryAttributes[]) {
    state.menuCategories = menuCategories
  }
}

const actions: ActionTree<MenuState, RootState> = {
  fetchMenuCategories: async ({ state, commit }) =>{
    if (! state.menuCategories) {
      const response = await axios.get<ApiResponse<MenuCategoryAttributes[]>>('/menu')
      commit('setMenuCategories', response.data.payload)
    }
  },
}

export const menu: Module<MenuState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
